import { FC, SVGProps } from 'react'

export const DollarSign: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M4 10.6667C4 12.1395 5.19391 13.3334 6.66667 13.3334H9.67544C10.9593 13.3334 12 12.2927 12 11.0089C12 10.0083 11.3597 9.12 10.4105 8.80359L5.58947 7.19657C4.64025 6.88017 4 5.99186 4 4.9913C4 3.70749 5.04074 2.66675 6.32455 2.66675H9.33333C10.8061 2.66675 12 3.86066 12 5.33341"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8 1.33337L8 14.6667"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
